(function () {
  const configEl = document.getElementById('FreeShippingAutoCodeConfig');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    console.warn('Free shipping auto code: invalid config', error);
    return;
  }

  const DEBOUNCE_MS = 300;
  let timer = null;
  let inFlight = false;
  let rerun = false;

  function cartEndpoint(path) {
    const root =
      (window.Shopify && Shopify.routes && Shopify.routes.root) ||
      (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.root_url) ||
      '/';
    if (root.endsWith('/')) return root.replace(/\/$/, '') + path;
    return root + path;
  }

  function normalizeCode(code) {
    return String(code || '').trim().toLowerCase();
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input instanceof URL) return input.href;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function headerValue(headers, name) {
    if (!headers) return '';
    if (typeof headers.get === 'function') return headers.get(name) || '';
    return headers[name] || '';
  }

  function isAutoRequest(input, init) {
    const initHeaders = init && init.headers;
    const inputHeaders = input && input.headers;
    return headerValue(initHeaders, 'X-Free-Shipping-Auto') === '1' || headerValue(inputHeaders, 'X-Free-Shipping-Auto') === '1';
  }

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?([?#]|$)/.test(url);
  }

  function currencyRate() {
    const rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    return rate > 0 ? rate : 1;
  }

  function desiredCode(cart) {
    const subtotal = Number(cart && cart.items_subtotal_price) || 0;
    const rate = currencyRate();

    if (config.isB2B) return null;

    const threshold = Number(config.threshold);
    if (!config.code || config.threshold == null || Number.isNaN(threshold)) return null;
    return subtotal >= Math.round(threshold * rate) ? config.code : null;
  }

  function currentCodes(cart) {
    return ((cart && cart.discount_codes) || []).map((entry) => entry.code).filter(Boolean);
  }

  function nextCodes(current, desired) {
    const managed = [config.code].map(normalizeCode).filter(Boolean);
    const kept = current.filter((code) => managed.indexOf(normalizeCode(code)) === -1);
    if (desired && kept.every((code) => normalizeCode(code) !== normalizeCode(desired))) {
      kept.push(desired);
    }
    return kept;
  }

  function sameCodes(left, right) {
    if (left.length !== right.length) return false;
    const a = left.map(normalizeCode).sort();
    const b = right.map(normalizeCode).sort();
    return a.every((code, index) => code === b[index]);
  }

  function refreshCartUi() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));

    const mainCart = document.querySelector('main-cart');
    if (!mainCart || !window.FoxTheme || !FoxTheme.utils || !FoxTheme.routes) return;

    const sectionId = FoxTheme.utils.getSectionId(mainCart);
    const cartId = `MainCart-${sectionId}`;

    fetch(`${FoxTheme.routes.root_url}?section_id=${sectionId}`)
      .then((response) => response.text())
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const current = document.getElementById(cartId);
        const updated = parsed.getElementById(cartId);
        if (current && updated) current.innerHTML = updated.innerHTML;
      })
      .catch((error) => {
        console.warn('Free shipping auto code: cart refresh failed', error);
      });
  }

  async function applyCodes(codes) {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Free-Shipping-Auto': '1',
    };

    const response = await fetch(cartEndpoint('/cart/update.js'), {
      method: 'POST',
      headers,
      body: JSON.stringify({ discount: codes.join(',') }),
    });
    const data = await response.json().catch(() => ({}));
    const applied = Array.isArray(data.discount_codes) ? currentCodes(data) : null;

    if (!response.ok || (applied && !sameCodes(applied, codes))) {
      const codeToAdd = codes.length ? codes[codes.length - 1] : '';
      console.warn(
        'Free shipping auto code: /cart/update.js did not apply the discount list. Fallback /discount/ can add a code, but cannot remove one.'
      );
      if (codeToAdd) {
        await fetch(cartEndpoint('/discount/' + encodeURIComponent(codeToAdd)), {
          headers: { 'X-Free-Shipping-Auto': '1' },
          redirect: 'manual',
        });
      }
    }

    refreshCartUi();
  }

  async function sync() {
    const response = await fetch(cartEndpoint('/cart.js'), {
      headers: { Accept: 'application/json', 'X-Free-Shipping-Auto': '1' },
    });
    if (!response.ok) throw new Error('cart.js request failed');

    const cart = await response.json();
    const current = currentCodes(cart);
    const desired = desiredCode(cart);
    const next = nextCodes(current, desired);
    if (sameCodes(current, next)) return;

    await applyCodes(next);
  }

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (inFlight) {
        rerun = true;
        return;
      }
      runSync();
    }, DEBOUNCE_MS);
  }

  async function runSync() {
    inFlight = true;
    try {
      await sync();
    } catch (error) {
      console.warn('Free shipping auto code:', error);
    } finally {
      inFlight = false;
      if (rerun) {
        rerun = false;
        scheduleSync();
      }
    }
  }

  const nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    const marked = isAutoRequest(input, init);
    const url = requestUrl(input);
    return nativeFetch(input, init).then((response) => {
      if (!marked && isCartMutation(url)) scheduleSync();
      return response;
    });
  };

  document.addEventListener('cart:updated', scheduleSync);

  if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, scheduleSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }
})();
